export var INTEGRATIONS_LOCAL_STORAGE_KEYS = {
    REFERRAL_ROCK_CODE: "bf_integrations_referral_rock_code",
    REFERRAL_ROCK_WCID: "bf_integrations_referral_rock_wcid",
    REFERRAL_ROCK_FIELD: "bf_integrations_referral_rock_field",
};
export var IntegrationsActions;
(function (IntegrationsActions) {
    IntegrationsActions["SET_INTEGRATION_CONFIG"] = "SET_INTEGRATION_CONFIG";
    IntegrationsActions["CLEAR_INTEGRATION_CONFIG"] = "CLEAR_INTEGRATION_CONFIG";
    IntegrationsActions["INTEGRATIONS_EVENT_QUERY_PARAMS_FOUND"] = "INTEGRATIONS_EVENT_QUERY_PARAMS_FOUND";
    IntegrationsActions["INTEGRATIONS_EVENT_BUYER_FIELDS_POSTED"] = "INTEGRATIONS_EVENT_BUYER_FIELDS_POSTED";
    IntegrationsActions["INTEGRATIONS_EVENT_ORDER_PLACED"] = "INTEGRATIONS_EVENT_ORDER_PLACED";
})(IntegrationsActions || (IntegrationsActions = {}));
